<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            User Access
          </div>
        </v-layout>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'U1', tags: 'C1'}"/>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'U1', tags: 'F1'}"/>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Human Resources
          </div>
        </v-layout>
        <v-container>
          <v-layout align-left rowclass="mt-2 ml-4">
            <v-btn :color="ui.btnColor" flat light :disabled="true">
              <v-icon left>
                date_range
              </v-icon>
              Leave Request
            </v-btn>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <v-btn :color="ui.btnColor" flat light :disabled="true">
              <v-icon left>
                groups
              </v-icon>
              Organisation
            </v-btn>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <v-btn :color="ui.btnColor" flat light :disabled="true">
              <v-icon left>
                paid
              </v-icon>
              Spend Claim
            </v-btn>
          </v-layout>
        </v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            App Operations
          </div>
        </v-layout>
        <v-container>
          <v-layout align-left rowclass="mt-2 ml-4"
          v-if="this.getUser.basic.act === false">
            <v-btn :color="ui.btnColorError" flat dark>
              <v-icon left>
                person
              </v-icon>
              User Not Active
            </v-btn>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4" :data="{btn: 'flat'}">
            <DataPrivacyCard :data="{btnSize: 'flat'}"/>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <TermsAndConditionsCard :data="{btnSize: 'flat'}"/>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <LicenceCard
            :data="{
              title: 'Licence Information',
              icon: 'dashboard_customize',
              colorTitle: this.ui.textSubheadingBoldBlue,
              colorIcon: this.ui.colorBlue}"
            />
          </v-layout>
        </v-container>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import tradeOptions from "@/data/options/mixins/tradeOptions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import LicenceCard from "@/admin/licence/components/LicenceCard";
import DataPrivacyCard from "@/admin/privacy/components/DataPrivacyCard";
import TermsAndConditionsCard from "@/admin/tc/components/TermsAndConditionsCard";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";
export default {
  computed: {
    ...mapGetters(["getUser"])
  },
  mixins: [docRevsModFunctions, ruleTextfield, apptheme, tradeOptions],
  components: {
    DataPrivacyCard,
    LicenceCard,
    TermsAndConditionsCard,
    GetAccessListPage
  }
};
</script>
